import { useSidebarNavigationOptional } from '@components/contexts/SidebarNavigationContext';

export type PromptBarMode = 'search' | 'chat';

/**
 * Derives the prompt bar mode from the current sidebar view: **search** only on the job-search
 * form (`new-job-search-form`, i.e. /mc/search) and its results (`candidateSearch` /
 * `editSearch` / `keyword`); **chat** on everything else (coaching, landings, company pages,
 * unknown). Context is NOT consulted — a company viewing /mc/search must still get search mode.
 *
 * `override` lets a caller force a mode (e.g. company leaf pages that render a chat-only pill,
 * or pages where SidebarNavigationProvider is not mounted).
 */
export const usePromptBarMode = (override?: PromptBarMode): PromptBarMode => {
  const sidebarNav = useSidebarNavigationOptional();
  if (override) return override;

  const view = sidebarNav?.currentView;
  const isJobSearch = view === 'new-job-search-form'
    || (typeof view === 'object' && view !== null
      && ('candidateSearch' in view || 'editSearch' in view || 'keyword' in view));

  return isJobSearch ? 'search' : 'chat';
};
